{
  "en": {
    "itm": {
      "unsavedChanges": "You have unsaved changes on this tab. Are you sure you want to leave?",
      "partialSaveError": "Some sections could not be saved:"
    }
  },
  "fr": {
    "itm": {
      "unsavedChanges": "Vous avez des modifications non enregistrées sur cet onglet. Êtes-vous sûr de vouloir quitter ?",
      "partialSaveError": "Certaines sections n'ont pas pu être enregistrées :"
    }
  },
  "nl": {
    "itm": {
      "unsavedChanges": "U heeft niet-opgeslagen wijzigingen op dit tabblad. Weet u zeker dat u wilt afsluiten?",
      "partialSaveError": "Sommige secties konden niet worden opgeslagen:"
    }
  }
}
